module.exports = __webpack_public_path__ + "media/images/swift_guide_logo-26dd5d6173308d5019b5f182d459d40d.png";